import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Input, Radio } from 'src/components/UI/Forms/Inputs';


import { VehicleFirst } from 'src/utils/interfaces/interfaces';
import { VehiclesList } from 'src/components/Transporter/vehiclesList';

import VehicleCard from 'src/components/Transporter/vehicleCard';
import {
  FullName,
  SelectAnyValue,
  VehicleModelYear,
  VehiclePlateNumber,
} from 'src/utils/validations/formValidations';
import { useForm } from 'react-hook-form';
import CustomSelect from 'src/components/UI/Forms/Inputs/customSelect';
import {
  useAddVehicleMutation,
  useGetVehiclesListQuery,
  useSearchVehicleQuery,
  useUpdateVehicleMutation,
} from 'src/services/transporterVehicles/transporterVehicles';
import { VehicleBrands } from 'src/constants/constants';
import { UAEStates } from 'src/data/States';
import {
  RegistrationType,
  UAEPrivatePlateCodes,
} from 'src/data/LicensePlateCode';
import { getUser } from 'src/utils/user/user';
import DatePickerComponent from 'src/components/UI/Forms/Inputs/datePicker';
import CustomSnackbar from 'src/components/UI/Alerts/customSnackbar';
import { useTranslation } from 'react-i18next';
import { Countries, UAECode } from 'src/data/Countries';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "@heroui/react";
import { FaPenToSquare, FaPlus } from 'src/icons';

export interface IMembersProps { }
export function Vehicles(props: IMembersProps) {
  const user = getUser();
  const location = useLocation();

  useEffect(() => {
    if ((location.state as any)?.openAdd) {
      setShowAddVehicle(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const companyId = user?.company?._id || null;
  const { data: VehicleFirst, refetch: refetchVehicle } =
    useGetVehiclesListQuery(user?.company?._id);
  const [searchString, setSearchString] = useState<any>(null);
  const { data: VehicleFirstFiltered } = useSearchVehicleQuery(
    { companyId, search: searchString },
    { skip: !searchString || !companyId }
  );
  const [showVehicle, setShowVehicle] = useState(false);
  const [vehicleFullData, setVehicleFullData] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState<any>({});


  const [showAddVehicle, setShowAddVehicle] = useState(false);
  const [showEditVehicle, setShowEditVehicle] = useState(false);
  const [addVehicle] = useAddVehicleMutation();
  const [updateVehicle] = useUpdateVehicleMutation();

  const [emirates, setEmirates] = useState<string>('');
  const [mulkiyaExpiryDate, setMulkiyaExpiryDate] = useState<Date | null>(null);
  const [isDateError, setIsDateError] = useState(false);
  const [regType, setRegType] = useState<string>('');
  const [regCode, setRegCode] = useState<string>('');

  const datePickerRef = useRef<HTMLDivElement>(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    'success' | 'info' | 'warning' | 'error'
  >('success');

  const [country, setCountry] = useState<string>('AE');
  const [nonUAECountry, setNonUAECountry] = useState<string>('');

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors: formErrors },
  } = useForm();
  const errors = formErrors as any;
  const OnChangeSearch = (value: string) => {
    if (value.trim() === '') {
      setSearchString(null); // Reset search if input is empty
    } else {
      setSearchString(value); // Update with new search string
    }
  };
  useEffect(() => {
    if (searchString === null) {
      setVehicleFullData(VehicleFirst);
    }
    setVehicleFullData(VehicleFirst);
  }, [VehicleFirst, searchString]);

  useEffect(() => {
    if (!searchString) {
      // No search, display all vehicles
      setVehicleFullData(VehicleFirst || []);
    } else if (VehicleFirstFiltered) {
      // Apply search results
      setVehicleFullData(VehicleFirstFiltered);
    }
  }, [VehicleFirst, VehicleFirstFiltered, searchString]);

  const onAddVehicle = (data: any) => {
    if (!mulkiyaExpiryDate) {
      setIsDateError(true);
      return;
    }
    setIsDateError(false);

    if (regType === 'public') {
      setRegCode('');
      data.plate.code = '';
    }

    data['mulkiya'] = mulkiyaExpiryDate.toISOString().slice(0, 10);
    data['transportCompany'] = companyId;
    if (country === 'AE') {
      data['plateNumber'] = data.plate.code
        ? `${data.plate.type}-${data.plate.code}-${data.plate.number}`
        : `${data.plate.type}-${data.plate.number}`;
    } else {
      data['plateNumber'] = data.plate.number;
    }
    // delete data.vehicle;
    const _payload = data;

    addVehicle(_payload)
      .then((response: any) => {
        if (response && response.data) {
          setSnackbarMessage('Vehicle added successfully');
          setSnackbarSeverity('success');
          setOpenSnackbar(true);
          setShowAddVehicle(false);
          refetchVehicle();
          reset();
        } else if (response.error.data.message) {
          setSnackbarMessage(response.error.data.message);
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage('Something went wrong.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      });
  };



  const onUpdateVehicle = (data: any) => {
    if (!mulkiyaExpiryDate) {
      setIsDateError(true);
      return;
    }
    setIsDateError(false);
    data['mulkiya'] = mulkiyaExpiryDate.toISOString().slice(0, 10);
    data['transportCompany'] = companyId;
    if (country === 'AE') {
      data['plateNumber'] = data.plate.code
        ? `${data.plate.type}-${data.plate.code}-${data.plate.number}`
        : `${data.plate.type}-${data.plate.number}`;
    } else {
      data['plateNumber'] = data.plate.number;
    }
    const _payload = data;
    updateVehicle({ data: _payload, id: selectedVehicle._id })
      .then((response: any) => {
        if (response && response.data) {
          setSnackbarMessage('Vehicle updated successfully');
          setSnackbarSeverity('success');
          setOpenSnackbar(true);
          setShowAddVehicle(false);
          setShowEditVehicle(false);
          refetchVehicle();
          reset();
        } else if (response.error.data.message) {
          setSnackbarMessage(response.error.data.message);
          setSnackbarSeverity('error');
          setOpenSnackbar(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage('Something went wrong.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      });
  };

  useEffect(() => {
    if (isDateError && datePickerRef.current) {
      datePickerRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isDateError]);

  const onEditVehicle = (vehicle: any) => {
    setShowEditVehicle(true);
    setShowVehicle(false);

    // Ensure dropdown fields match the saved database state
    const vehicleCountry = vehicle?.plate?.country || 'AE';
    setEmirates(vehicle?.plate?.emirates || '');
    setCountry(vehicleCountry === UAECode ? UAECode : 'non-uae');
    setNonUAECountry(vehicleCountry !== UAECode ? vehicleCountry : '');
    setRegType(vehicle?.plate?.type || '');

    const plateParts = vehicle.plateNumber?.split('-') || [];

    if (plateParts.length === 3) {
      setRegCode(plateParts[1]);
    } else if (plateParts.length === 2 && vehicle?.plate?.type === 'private') {
      // In cases where they might just be Plate Code - Plate Number without Type prefix in legacy data
      setRegCode(plateParts[0]);
    } else {
      setRegCode('');
    }
  };

  const onAdd = () => {
    setShowAddVehicle(true);
    reset({
      vehicleMake: '',
      model: '',
      chassis: '',
    });
    setEmirates('');
    setCountry('AE');
    setNonUAECountry('');
    setRegType('');
    setRegCode('');
    setMulkiyaExpiryDate(null);
  };

  useEffect(() => {
    // Reset form with new vehicle data when `selectedVehicle` changes
    reset({
      vehicleMake: selectedVehicle?.vehicleMake || '',
      model: selectedVehicle?.model || '',
      chassis: selectedVehicle.chassis || '',
    });
  }, [selectedVehicle, reset]);

  useEffect(() => {
    if (selectedVehicle.mulkiya) {
      const newDate = new Date(selectedVehicle.mulkiya);
      setMulkiyaExpiryDate(newDate);
    } else {
      setMulkiyaExpiryDate(null); // or some default value
    }
  }, [selectedVehicle.mulkiya]);

  const handleDateChange = (date: Date | null) => {
    setMulkiyaExpiryDate(date); // Update state
    setIsDateError(!date); // Set error state based on validity
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-screen px-6 py-4 overflow-y-auto" style={{ backgroundColor: 'var(--bg-base)', color: 'var(--text-main)' }}>
        <CustomSnackbar
          open={openSnackbar}
          handleClose={() => setOpenSnackbar(false)}
          message={snackbarMessage}
          severity={snackbarSeverity}
          anchorOrigin={{ vertical: 'top', horizontal: 'end' }}
        />
        <div className="sticky top-0 z-10 py-6 pb-4" style={{ backgroundColor: 'var(--bg-base)' }}>
          <div className="flex items-center justify-between">
            <h3 className="text-2xl ms-4">{t('nav_bar.vehicles')}</h3>
            <div className="flex justify-end gap-4">
              <Button
                variant='solid'
                size="sm"
                className="rounded-md shadow-lg m-1 p-5 font-semibold text-sm transition-colors duration-200"
                style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                onPress={() => onAdd()}
                startContent={<FaPlus />}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
              >
                {t('vehicle.add_vehicle')}
              </Button>
              <Input
                type="text"
                placeholder={t('vehicle.search_placeholder')}
                inputClassName="bg-[var(--bg-surface)] border border-[var(--border-light)] shadow-sm rounded-lg placeholder:text-[var(--text-muted)] text-[var(--text-main)] h-[45px]"
                onChange={(e: any) => OnChangeSearch(e.target.value)}
                iconUrl="/assets/icons/search.svg"
              ></Input>
            </div>
          </div>
        </div>
        <section>
          <div className="rounded-lg max-h-[70vh] overflow-y-auto">
            {vehicleFullData && vehicleFullData?.length !== 0 ? (
              vehicleFullData?.map((vehicles: any) => (
                <VehiclesList
                  key={vehicles?._id}
                  vehicle={vehicles}
                  OnAction={(vehicles: VehicleFirst) => {
                    setSelectedVehicle(vehicles);
                    setShowVehicle(true);
                  }}
                  onClose={() => {
                    setShowVehicle(true);
                  }}
                />
              ))
            ) : (
              <div className="px-6" style={{ backgroundColor: 'var(--bg-base)', color: 'var(--text-main)' }}>
                <div className="sticky top-0 z-10 flex flex-col items-center py-8 pb-4 mt-48" style={{ backgroundColor: 'var(--bg-base)' }}>
                  <h3 className="col-span-2 mt-10 mb-2 text-2xl tracking-wide text-center" style={{ color: 'var(--text-main)' }}>
                    {t('vehicle.no_vehicle')}
                  </h3>
                  <div className="w-[100px] mt-2 h-1 bg-gradient-to-r from-transparent via-[var(--color-primary)] to-transparent"></div>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
      <Drawer
        isOpen={showAddVehicle}
        onClose={() => setShowAddVehicle(false)}
        className="w-1/3"
        classNames={{ closeButton: 'm-2 p-2', header: 'px-6' }}
        style={{ backgroundColor: 'var(--bg-surface)' } as React.CSSProperties}
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-2xl" style={{ color: 'var(--text-main)' }}>
                {t('vehicle.add_vehicle')}
              </DrawerHeader>
              <DrawerBody>
                <form className="h-[80vh] overflow-y-scroll pe-5">
                  <CustomSelect
                    name="vehicleMake"
                    id="type"
                    options={VehicleBrands}
                    label={t('vehicle.make')}
                    placeholder={t('vehicle.select_make')}
                    setValue={setValue}
                    validation={SelectAnyValue}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    selectClassName="w-full"
                    error={errors.vehicleMake}
                    errorText={t('vehicle.error_messages.make')}
                    register={register}
                  />
                  <Input
                    type="text"
                    name="model"
                    label={t('vehicle.model')}
                    placeholder={t('vehicle.enter_model')}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    register={register}
                    validation={VehicleModelYear}
                    error={errors.model}
                    errorText={t('vehicle.error_messages.model')}
                  />
                  <Radio
                    name="plate.country"
                    label={t('vehicle.type')}
                    options={[
                      { code: 'AE', name: t('vehicle.uae') },
                      { code: 'non-uae', name: t('vehicle.non_uae') },
                    ]}
                    register={register}
                    validation={SelectAnyValue}
                    defaultValue={
                      country ? (country === UAECode ? UAECode : 'non-uae') : ''
                    }
                    error={errors.plate?.country}
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    className="mb-6"
                    onChange={(value: string) => {
                      if (value === 'AE') {
                        setValue('plate.country', value);
                      }
                      setCountry(value);
                    }}
                  />
                  {country === 'AE' ? (
                    <>
                      <CustomSelect
                        name="plate.emirates"
                        label={t('vehicle.emirate')}
                        labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                        options={UAEStates}
                        defaultValue={emirates}
                        placeholder={t('vehicle.select_emirate')}
                        className="mb-6"
                        setValue={setValue}
                        validation={SelectAnyValue}
                        error={errors.plate?.emirates}
                        errorText={t('vehicle.error_messages.emirate')}
                        onChange={(value: any) => setEmirates(value)}
                        register={register}
                      />
                      <CustomSelect
                        name="plate.type"
                        label={t('vehicle.reg_type')}
                        labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                        options={RegistrationType}
                        defaultValue={regType}
                        placeholder={t('vehicle.select_reg_type')}
                        className="mb-6"
                        register={register}
                        setValue={setValue}
                        validation={SelectAnyValue}
                        error={errors.plate?.type}
                        errorText={t('vehicle.error_messages.reg_type')}
                        onChange={(value: any) => setRegType(value)}
                      />
                      {country === 'AE' && emirates && regType === 'private' && (
                        <CustomSelect
                          name="plate.code"
                          label={t('vehicle.code')}
                          labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                          options={emirates ? UAEPrivatePlateCodes[emirates] : []}
                          placeholder={t('vehicle.select_code')}
                          className="mb-6"
                          selectClassName="shadow-sm border border-[var(--border-light)] placeholder:text-[var(--text-muted)] text-[var(--text-main)]"
                          register={register}
                          setValue={setValue}
                          validation={SelectAnyValue}
                          onChange={(value: any) => setRegCode(value)}
                          error={errors.plate?.code}
                          errorText={t('vehicle.error_messages.code')}
                          defaultValue={regCode}
                        />
                      )}
                    </>
                  ) : (
                    <CustomSelect
                      name="plate.country"
                      label={t('vehicle.country')}
                      labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                      options={Countries}
                      defaultValue={nonUAECountry}
                      placeholder={t('vehicle.select_country')}
                      className="mb-6"
                      register={register}
                      setValue={setValue}
                      error={errors.plate?.country}
                      errorText={t('vehicle.error_messages.country')}
                      onChange={(value: any) => setNonUAECountry(value)}
                    />
                  )}
                  <Input
                    name="plate.number"
                    type="text"
                    label={t('vehicle.plate_no')}
                    placeholder={t('vehicle.enter_plate_no')}
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    register={register}
                    validation={VehiclePlateNumber}
                    error={errors.plate?.number}
                    errorText={t('vehicle.error_messages.plate_number')}
                    maxLength={5}
                  />
                  <Input
                    type="text"
                    name="chassis"
                    label={t('vehicle.chassis')}
                    placeholder={t('vehicle.enter_chassis')}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    register={register}
                    validation={FullName}
                    error={errors.chassis}
                    errorText={t('vehicle.error_messages.chassis')}
                  />
                  <div ref={datePickerRef}>
                    <DatePickerComponent
                      selectedDate={mulkiyaExpiryDate}
                      onChange={handleDateChange}
                      isDateError={isDateError}
                      minDate={new Date()}
                      label={t('vehicle.mulkiya_expiry')}
                      placeholder="MM/DD/YYYY"
                      errorText={t('vehicle.error_messages.mulkiya_expiry')}
                      className="!mb-2"
                    />
                  </div>
                </form>
              </DrawerBody>
              <DrawerFooter className="m-auto">
                <Button
                  variant="solid"
                  size="md"
                  className="p-3 shadow-lg w-36 font-semibold transition-colors"
                  style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                  onPress={(e) => {
                    handleSubmit((data) => onAddVehicle(data))();
                  }}
                >
                  {t('vehicle.add_vehicle')}
                </Button>
              </DrawerFooter>
            </>
          )}
        </DrawerContent>
      </Drawer>
      <Drawer
        isOpen={showEditVehicle}
        onClose={() => setShowEditVehicle(false)}
        className="w-1/3"
        classNames={{ closeButton: 'm-2 p-2', header: 'px-6' }}
        style={{ backgroundColor: 'var(--bg-surface)' } as React.CSSProperties}
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-2xl" style={{ color: 'var(--text-main)' }}>
                {t('vehicle.edit_vehicle')}
              </DrawerHeader>
              <DrawerBody>
                <form className="h-[80vh] overflow-y-scroll pe-5">
                  <CustomSelect
                    name="vehicleMake"
                    id="type"
                    options={VehicleBrands}
                    label={t('vehicle.make')}
                    placeholder={t('vehicle.select_make')}
                    defaultValue={selectedVehicle?.vehicleMake || ''}
                    register={register}
                    setValue={setValue}
                    validation={SelectAnyValue}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    selectClassName="w-full"
                    error={errors.vehicleMake}
                    errorText={t('vehicle.error_messages.make')}
                  />
                  <Input
                    type="text"
                    name="model"
                    label={t('vehicle.model')}
                    placeholder={t('vehicle.enter_model')}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    defaultValue={selectedVehicle?.model || ''}
                    register={register}
                    validation={VehicleModelYear}
                    error={errors.model}
                    errorText={t('vehicle.error_messages.model')}
                  />
                  <Radio
                    name="plate.country"
                    label={t('vehicle.type')}
                    options={[
                      { code: 'AE', name: t('vehicle.uae') },
                      { code: 'non-uae', name: t('vehicle.non_uae') },
                    ]}
                    register={register}
                    validation={SelectAnyValue}
                    defaultValue={country === UAECode ? UAECode : 'non-uae'}
                    error={errors.plate?.country}
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    className="mb-6"
                    disabled
                    onChange={(value: string) => {
                      if (value === 'AE') {
                        setValue('plate.country', value);
                      }
                      setCountry(value);
                    }}
                  />
                  {country === 'AE' ? (
                    <>
                      <CustomSelect
                        name="plate.emirates"
                        label={t('vehicle.emirate')}
                        labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                        options={UAEStates}
                        defaultValue={selectedVehicle?.plate.emirates}
                        placeholder={t('vehicle.select_emirate')}
                        className="mb-6"
                        register={register}
                        setValue={setValue}
                        validation={SelectAnyValue}
                        error={errors.plate?.emirates}
                        errorText="Select a state"
                        onChange={(value: any) => setEmirates(value)}
                      ></CustomSelect>
                      <CustomSelect
                        name="plate.type"
                        label={t('vehicle.reg_type')}
                        labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                        options={RegistrationType}
                        defaultValue={selectedVehicle?.plate.type}
                        placeholder={t('vehicle.select_reg_type')}
                        register={register}
                        setValue={setValue}
                        validation={SelectAnyValue}
                        error={errors.plate?.type}
                        errorText="Select an option"
                        onChange={(value: any) => setRegType(value)}
                      ></CustomSelect>
                      {country === 'AE' && emirates && regType === 'private' && (
                        <CustomSelect
                          name="plate.code"
                          label="Code"
                          labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                          options={
                            emirates ? UAEPrivatePlateCodes[emirates] : []
                          }
                          placeholder="Select code"
                          className="mb-6"
                          register={register}
                          setValue={setValue}
                          validation={SelectAnyValue}
                          // value={regCode}
                          onChange={(value: any) => setRegCode(value)}
                          error={errors.plate?.code}
                          errorText="Select a code"
                          defaultValue={selectedVehicle?.plate.code}
                        ></CustomSelect>
                      )}
                    </>
                  ) : (
                    <CustomSelect
                      name="plate.country"
                      label={t('vehicle.country')}
                      labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                      options={Countries}
                      defaultValue={nonUAECountry}
                      placeholder={t('vehicle.select_country')}
                      className="mb-6"
                      register={register}
                      setValue={setValue}
                      validation={SelectAnyValue}
                      error={errors.plate?.country}
                      errorText={t('vehicle.error_messages.country')}
                      onChange={(value: any) => setNonUAECountry(value)}
                    />
                  )}
                  <Input
                    name="plate.number"
                    type="text"
                    label={t('vehicle.plate_no')}
                    placeholder={t('vehicle.enter_plate_no')}
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    register={register}
                    validation={VehiclePlateNumber}
                    error={errors.plate?.number}
                    errorText="Enter a 5 digit truck number"
                    defaultValue={
                      country === 'AE'
                        ? selectedVehicle?.plateNumber?.match(/\d+$/)?.[0] || ''
                        : selectedVehicle?.plateNumber || ''
                    }
                    maxLength={5}
                  ></Input>
                  <Input
                    type="text"
                    name="chassis"
                    label={t('vehicle.chassis')}
                    placeholder={t('vehicle.enter_chassis')}
                    className="!mb-6"
                    labelClassName="!text-[var(--text-muted)] !text-xs !mb-1"
                    register={register}
                    validation={FullName}
                    defaultValue={selectedVehicle.chassis}
                    error={errors.chassis}
                    errorText="Enter chassis"
                  />
                  <div ref={datePickerRef}>
                    <DatePickerComponent
                      selectedDate={mulkiyaExpiryDate}
                      onChange={(date: Date | null) => {
                        setMulkiyaExpiryDate(date);
                        setIsDateError(false);
                      }}
                      isDateError={isDateError}
                      minDate={new Date()}
                      label={t('vehicle.mulkiya_expiry')}
                      placeholder="DD/MM/YYYY"
                      errorText={t('vehicle.err_mulkiya_expiry')}
                    />
                  </div>
                </form>
              </DrawerBody>
              <DrawerFooter className="m-auto">
                <Button
                  className="p-3 shadow-lg w-36 font-semibold transition-colors"
                  style={{ backgroundColor: 'var(--color-primary)', color: 'var(--text-invert)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary-hover)')}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--color-primary)')}
                  onClick={handleSubmit((d) => onUpdateVehicle(d))}
                >
                  Save
                </Button>
              </DrawerFooter>
            </>
          )}
        </DrawerContent>
      </Drawer>
      <Drawer
        isOpen={showVehicle}
        onClose={() => setShowVehicle(false)}
        className="w-[30%]"
        classNames={{ closeButton: 'm-2 p-2', header: 'px-6' }}
        style={{ backgroundColor: 'var(--bg-surface)' } as React.CSSProperties}
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-2xl" style={{ color: 'var(--text-main)' }}>
                {t('vehicle.vehicle_details')}
              </DrawerHeader>
              <DrawerBody>
                <div className="px-4 py-10" style={{ color: 'var(--text-main)' }}>
                  {VehicleFirst && (
                    <VehicleCard vehicle={selectedVehicle as VehicleFirst} />
                  )}
                </div>
              </DrawerBody>
              <DrawerFooter className="m-auto">
                <Button
                  variant="solid"
                  size="md"
                  className="w-full p-3 rounded-lg shadow-lg transition-colors duration-200"
                  style={{ backgroundColor: 'var(--bg-overlay)', border: '1px solid var(--border-light)', color: 'var(--text-main)' }}
                  onClick={() => onEditVehicle(selectedVehicle)}
                  startContent={<FaPenToSquare />}
                >
                  {t('button.edit')}
                </Button>
                {/* <Button
                  variant="bordered"
                  size="md"
                  color="danger"
                  className="w-full p-3 text-white rounded-lg"
                  onClick={() => setShowConfirm(true)}
                >
                  {t('button.delete')}
                </Button> */}
              </DrawerFooter>
            </>
          )}
        </DrawerContent>
      </Drawer>
      {/* <Modal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        align="center"
        className="rounded-lg shadow-card mx-auto w-[25%] top-10 start-1/2 transform -translate-x-1/2" style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-main)" }}
      >
        <div className="p-6 text-center text-white">
          <img
            src={`/assets/icons/orders/jobDetails/truck-big.svg`}
            alt="lock"
            className="mx-auto mb-3"
          />
          <h3 className="mb-2 text-lg font-semibold">Remove Vehicle?</h3>
          <p className="text-white/[0.85] text-sm mb-6">
            You are about to permanently remove this vehicle from the list. This
            action cannot be undone. Do you wish to proceed?
          </p>
          <div className="grid grid-cols-2 gap-4 mt-3 mb-3">
            <button
              className="p-3 text-white border border-white rounded-lg "
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>
            <button
              className="p-3 text-white rounded-lg bg-danger "
              onClick={() => {
                onDeleteVehicle();
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal> */}
    </>
  );
}
